module.exports = __webpack_public_path__ + "static/img/c60fa18a131267c9b847dce535ef135c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Mode3-show-1.png
// module id = CF3z
// module chunks = 1